// Lib
import { createStructuredSelector } from 'reselect';

// Utils
import {
    currentBoardIsPublishedSelector,
    currentBoardPublishedPermissionIdSelector,
    currentBoardSpecificUserPermissionsSelector,
    publishedAncestorBoardSelector,
} from '../../../../../../utils/permissions/elementPermissionsSelector';
import { getCurrentBoard } from '../../../../../../element/selectors/currentBoardSelector';
import getGridSize from '../../../../../../utils/grid/gridSizeSelector';
import { getPlatformDetailsSelector } from '../../../../../../platform/platformSelector';

export const publishBoardPopupSelector = createStructuredSelector({
    gridSize: getGridSize,
    currentBoard: getCurrentBoard,
    publishedAncestorBoard: publishedAncestorBoardSelector,
    currentBoardIsPublished: currentBoardIsPublishedSelector,
    specificUserPermissions: currentBoardSpecificUserPermissionsSelector,
    currentBoardPublishedPermissionId: currentBoardPublishedPermissionIdSelector,
    platformDetails: getPlatformDetailsSelector,
});
